import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import styles from "../../assets/styles/loan.module.css";
import Strings from "../../utils/stringUtil";
import { fetchImpactStories } from "../../utils/businessLoanUtil";
import { Link } from "react-router-dom";
import Routes from "../../utils/routesUtil";
import { formatDate, textTruncate } from "../../utils/util";
import AppIcons from "../../utils/appIcons";
import { isMobile } from "../../utils/responsiveUtil";

function ImpactStories() {
  const titleMaxLength = 88;
  const descMaxLength = 150;
  const [impactStories, setImpactStories] = useState([]);
  const [isLoading, setLoading] = useState(false);

  async function loadStories() {
    setLoading(true);
    try {
      const stories = await fetchImpactStories();
      stories?.length && setImpactStories(stories);
      setLoading(false);
    } catch (_err) {
      setLoading(false);
    }
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      impactStories?.length == 0 && loadStories();
    }, 100);
    return () => clearTimeout(timer); /* removing duplicating calling */
  }, []);

  return (
    <Box className={`container`}>
      {isLoading ? (
        <Box pt="4px" pb={"96px"} display={"flex"} justifyContent={"center"}>
          <div className="dot-falling-loader" />
        </Box>
      ) : (
        impactStories?.length > 0 && (
          <Box
            pb={"76px"}
            style={{ transform: isMobile ? "scale(1)" : "scale(0.97)" }}
          >
            <Typography className={styles.loanTitle}>
              {Strings.womenImpactStoriesTitle}
            </Typography>
            <Typography className={styles.loanDescription}>
              {Strings.womenImpactStoriesDesc}
            </Typography>

            <Box
              display={"flex"}
              gap="20px"
              mt={"44px"}
              justifyContent={"center"}
              position={"relative"}
              flexWrap={"wrap"}
              zIndex={1}
            >
              {renderVectors()}

              {impactStories.map((story, index) => {
                return (
                  <Box
                    key={index}
                    className={styles.impactStoryCard}
                    onClick={() =>
                      story?.url && window.open(story.url, "_blank")
                    }
                  >
                    {/* title section */}
                    {story?.title && (
                      <Typography className={styles.impactStoryCardTitle}>
                        {textTruncate(story.title, titleMaxLength)}
                      </Typography>
                    )}

                    {/* description section */}
                    <Box className={styles.impactStoryDescWrapper}>
                      {story?.description && (
                        <Typography className={styles.impactStoryCardDesc}>
                          {textTruncate(story.description, descMaxLength)}{" "}
                          {story.description.length > descMaxLength && (
                            <span
                              className={styles.readMoreText}
                              onClick={() =>
                                story?.url && window.open(story?.url, "_blank")
                              }
                            >
                              read more
                            </span>
                          )}
                        </Typography>
                      )}
                      {/* banner section */}
                      {story?.bannerUrl && (
                        <Box width={"100%"}>
                          <img
                            src={story?.bannerUrl}
                            alt=""
                            width={isMobile ? "100%" : 211}
                            height={128}
                            className={styles.impactStoryCardBanner}
                          />
                        </Box>
                      )}
                    </Box>

                    {/* meta details section */}
                    <Typography className={styles.metaDetails}>
                      {formatDate(story?.createdAt)}{" "}
                      {story?.readTime && (
                        <>
                          <img width={13} src={AppIcons.icGreyCircle} />
                          {story.readTime + " min read"}{" "}
                        </>
                      )}
                    </Typography>
                  </Box>
                );
              })}
            </Box>

            {/* read more btn */}
            {impactStories?.length > 1 && (
              <Box
                className={styles.readMoreBtnWrapper}
                position={"relative"}
                zIndex={1}
              >
                <Link
                  className={styles.readMoreBtn}
                  to={Routes.BLOG}
                  target="_blank"
                >
                  {Strings.readMoreBlogs}
                </Link>
              </Box>
            )}
          </Box>
        )
      )}
    </Box>
  );
}

function renderVectors() {
  return (
    <>
      <img
        src={AppIcons.imgImpactLeftCircles}
        className={styles.impactVectorLeft}
      />

      <img
        src={AppIcons.imgImpactRightCircles}
        className={styles.impactVectorRight}
      />
      <img src={AppIcons.icGreenCircle} className={styles.impactVectorTop} />
    </>
  );
}

export default ImpactStories;
